var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardSession(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12445 15.202L13.0658 12.2476C13.1988 12.1671 13.2653 12.0494 13.2653 11.8945C13.2653 11.7397 13.1988 11.6282 13.0658 11.5415L8.12445 8.58709C7.97814 8.48799 7.82518 8.4818 7.67222 8.56851C7.51926 8.65522 7.43945 8.7791 7.43945 8.94633V14.8489C7.43945 15.0162 7.51926 15.14 7.67222 15.2206C7.82518 15.3073 7.97814 15.3011 8.12445 15.202Z",
    fill: "#3F5056"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56425 18.508C2.07877 18.508 1.65979 18.347 1.31396 18.0249C0.961487 17.7029 0.788574 17.3127 0.788574 16.8605V6.95059C0.788574 6.49845 0.961487 6.10825 1.30731 5.78618C1.65314 5.46411 2.07212 5.29688 2.56425 5.29688H16.7497C17.2352 5.29688 17.6542 5.45791 18 5.77998C18.3458 6.10206 18.5187 6.49226 18.5187 6.9444V16.8543C18.5187 17.3065 18.3458 17.6967 18 18.0187C17.6542 18.3408 17.2352 18.5019 16.7497 18.5019H2.56425V18.508ZM2.56425 16.8605H16.7497V6.95059H2.56425V16.8605Z",
    fill: "#3F5056"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.319 4.031H2.47949V2.83203H16.319V4.031Z",
    fill: "#3F5056"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1963 1.82788H5.18457V0.628906H14.1963V1.82788Z",
    fill: "#3F5056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSession);
export default __webpack_public_path__ + "static/media/dashboard_session.fc860a103176162beaa26b249f4e5f1f.svg";
export { ForwardRef as ReactComponent };